import axios from "axios";
import Config from "../utils/Config";

class PolicyService {
  getAuthHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };
  }

  async getPolicies(policy_type) {
    try {
      const response = await axios.get(
        `${Config.apiUrl}/policy/get/travel_insurance/${policy_type}`,
        this.getAuthHeaders()
      );
      return {
        status: true,
        message: response.data.data?.reason || "Policies fetched successfully",
        data: response.data.data,
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          "An error occurred while getting policies",
        data: null,
      };
    }
  }

  async getLifeInsurancePolicies() {
    try {
      const response = await axios.get(
        `${Config.apiUrl}/policy/get/life_insurance/life_insurance`,
        this.getAuthHeaders()
      );
      return {
        status: true,
        message:
          response.data.data?.reason ||
          "Life insurance policies fetched successfully",
        data: response.data.data,
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          "An error occurred while getting life insurance policies",
        data: null,
      };
    }
  }

  async getGeneralInsurancePolicies(policy_type = null) {
    try {
      const endpoint = policy_type
        ? `${Config.apiUrl}/policy/get/general_insurance/${policy_type}`
        : `${Config.apiUrl}/policy/get/general_insurance`;

      const response = await axios.get(endpoint, this.getAuthHeaders());
      return {
        status: true,
        message:
          response.data.data?.reason ||
          "General insurance policies fetched successfully",
        data: response.data.data,
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          "An error occurred while getting general insurance policies",
        data: null,
      };
    }
  }

  async getTripSecureInsurancePolicies(policy_type = null) {
    try {
      const endpoint = policy_type
        ? `${Config.apiUrl}/policy/get/tripsecure_insurance/${policy_type}`
        : `${Config.apiUrl}/policy/get/tripsecure_insurance`;

      const response = await axios.get(endpoint, this.getAuthHeaders());
      return {
        status: true,
        message:
          response.data.data?.reason ||
          "TripSecure insurance policies fetched successfully",
        data: response.data.data,
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          "An error occurred while getting TripSecure insurance policies",
        data: null,
      };
    }
  }

  async getTravelInsurancePolicies() {
    try {
      const response = await axios.get(
        `${Config.apiUrl}/policy/get/travel_insurance/travel_insurance`,
        this.getAuthHeaders()
      );
      return {
        status: true,
        message:
          response.data.data?.reason ||
          "Travel insurance policies fetched successfully",
        data: response.data.data,
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          "An error occurred while getting travel insurance policies",
        data: null,
      };
    }
  }

  async purchasePolicy(payload, policy_slug) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/user/policy/purchase/${policy_slug}`,
        payload,
        this.getAuthHeaders()
      );
      return {
        status: true,
        message: response.data.data?.reason || "Policy purchased successfully",
        data: response.data.data,
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          "An error occurred while purchasing policy",
        data: null,
      };
    }
  }

  async getPurchasedPolicies() {
    try {
      const response = await axios.get(
        `${Config.apiUrl}/user/policy/get/all/purchased`,
        this.getAuthHeaders()
      );
      return {
        status: true,
        message:
          response.data.data?.reason ||
          "Purchased policies fetched successfully",
        data: response.data.data,
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          "An error occurred while getting purchased policies",
        data: null,
      };
    }
  }

  async getPolicy(policy_slug) {
    try {
      const response = await axios.get(
        `${Config.apiUrl}/show/policy/${policy_slug}`,
        this.getAuthHeaders()
      );
      return {
        status: true,
        message: response.data.data?.reason || "Policy fetched successfully",
        data: response.data.data,
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          "An error occurred while fetching policy",
        data: null,
      };
    }
  }

  async requestPolicyCancellation(purchaseSlug) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/user/cancel/purchased_policy/${purchaseSlug}`,
        {},
        this.getAuthHeaders()
      );

      return {
        status: true,
        message:
          response.data.data?.reason ||
          "Cancellation request submitted successfully",
        data: response.data.data,
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          "An error occurred while requesting policy cancellation",
        data: null,
      };
    }
  }
}

const policyService = new PolicyService();
export default policyService;
